<template>
  <div>
    <div class="flex items-center flex-col">
      <div class="my-3 text-center">
        <span class=" block   text-2xl">Collections</span>
        <span class="block font-semibold text-lg">₦ 877,908.50</span>
        <span class="block text-gray-500">102 Receivables</span>
      </div>

      <apexchart
        type="donut"
        width="380"
        :options="chartOptions"
        :series="series"
      >
      </apexchart>
    </div>

    <div class="my-3 px-3 w-full">
      <div class=" w-full flex my-3 justify-between">
        <select class=" bg-transparent font-semibold">
          <option value="sss">Past 7 Days</option>
        </select>

        <button class="text-primary-yellow">View All</button>
      </div>
    </div>

    <div class=" mx-3 mt-4 mb-3">
      <div class="grid grid-cols-12 mb-1">
        <span class=" col-span-6 text-left  text-gray-500">Customer</span>
        <span class=" col-span-6 text-right  text-gray-500">Amount</span>
      </div>
      <div
        v-for="(i, index) in 3"
        :key="index"
        class="grid grid-cols-12 p-1 "
        :class="{ 'bg-gray-100': index % 2 == 0 }"
      >
        <span class=" col-span-6 font-semibold text-black ">A & B Co.</span>

        <span class=" col-span-6 text-right font-semibold text-black"
          >₦ 1,004,800.22</span
        >
      </div>
      <div class=" grid grid-cols-2 py-1" style="border-top:1px solid lightgrey">
        <span class=" font-semibold  text-primary-yellow">TOTAL</span>
        <span class=" font-semibold text-right">₦2,714,550.00</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      series: [30, 50, 10, 10],
      chartOptions: {
        chart: {
          width: 380,
          type: "donut",
        },
        colors: ["#D72638", "#7A90A7", "#09B78A", "#FCC210"],
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
          offsetY: 0,
        },
        labels: [
          "Paid Today",
          "Past 7 Days",
          "Past 30 Days",
          "More than 30 Days",
        ],
      },
    };
  },
};
</script>

<style></style>
